module.exports = __webpack_public_path__ + "static/media/analytics.e0211a2a.svg";